<template>
  <div>
    <!-- <div class="snowflakes"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div> -->
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Marcar ponto</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8" style="text-align: left">
            <button
              :class="[
                'check-box',
                'btn',
                { odd: index % 2 == 0 },
                { even: index % 2 != 0 },
              ]"
              :disabled="!(quickAccess.length < 4)"
              v-for="(button, index) in buttons"
              :key="button.number"
            >
              <div class="check-content" @click="addNumber(button.number)">
                {{ button.number }}
              </div>
            </button>
          </div>
          <div class="col-md-4">
            <div class="quick-access-display">
              {{ quickAccess }}
            </div>
            <div class="row" id="check-backspace-container">
              <button
                class="btn col-md-12"
                id="check-backspace"
                :class="['btn', 'check-button-right']"
                @click="removeOne()"
              >
                <i class="fas fa-long-arrow-alt-left"></i>
                Apagar
              </button>
            </div>

            <div id="check-user-container" class="row">
              <div class="col-md-4">
                <img
                  id="check-user-image"
                  v-if="userChecking.photo"
                  :src="userChecking.photo"
                />
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-12">
                    {{ userChecking.name }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-muted">
                    {{ userChecking.email }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row" id="check-check-container" v-show="checkEnabled">
              <button
                class="btn col-md-12"
                id="check-check"
                :class="['btn', 'check-button-right']"
                @click="makeCheck"
              >
                <!-- <i class="fas fa-long-arrow-alt-left"></i> -->
                Marcar
                <br />
                {{ nextCheckDescription }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      step: 1,
      userChecking: {
        name: "",
      },
      nextCheckDescription: "",
      quickAccess: "",
      buttons: [
        {
          number: 1,
        },
        {
          number: 2,
        },
        {
          number: 3,
        },
        {
          number: 4,
        },
        {
          number: 5,
        },
        {
          number: 6,
        },
        {
          number: 7,
        },
        {
          number: 8,
        },
        {
          number: 9,
        },
      ],
    };
  },
  computed: {
    checkEnabled: function () {
      const self = this;
      return self.quickAccess.length === 4 && self.userChecking.id;
    },
  },
  methods: {
    removeOne() {
      const self = this;
      if (self.quickAccess.length === 4) {
        self.clearUserChecking();
      }
      self.quickAccess = self.quickAccess.substring(
        0,
        self.quickAccess.length - 1
      );
    },
    clearUserChecking() {
      const self = this;
      self.userChecking = {
        name: "",
      };
    },
    addNumber(number) {
      const self = this;
      if (!(self.quickAccess.length < 4)) return;

      self.quickAccess += number;

      if (self.quickAccess.length === 4) {
        self.check();
      }
    },
    makeCheck: function () {
      const self = this;
      self.loading = true;
      const api = this.$store.state.api + "checks";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", "Ponto marcado com sucesso", "success");
          self.clearAll();
          self.loading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.clearAll();
          self.loading = false;
        });
    },
    clearAll: function () {
      const self = this;

      (self.quickAccess = ""),
        (self.userChecking = {
          name: "",
        });
    },
    makeFormData: function () {
      const self = this;

      let fd = new FormData();
      fd.append("user_id", self.userChecking.id);

      return fd;
    },
    check: function () {
      const self = this;
      self.loading = true;
      const api =
        this.$store.state.api + "users?quick_access=" + self.quickAccess;

      self.$http
        .get(api)
        .then((response) => {
          let foundUser = response.data.data;
          if (foundUser.length === 1) {
            self.step = 2;

            let userChecking = response.data.data[0];
            //Verifying quantity of checks today
            const todayChecks =
              this.$store.state.api + "checks/today?user_id=" + userChecking.id;
            self.$http
              .get(todayChecks)
              .then((response) => {
                let checks = response.data;
                if (checks.length === 0) {
                  self.nextCheckDescription = "Entrada";
                } else if (checks.length === 1) {
                  self.nextCheckDescription = "Almoço";
                } else if (checks.length === 2) {
                  self.nextCheckDescription = "Volta almoço";
                } else if (checks.length === 3) {
                  self.nextCheckDescription = "Saída";
                } else {
                  self.nextCheckDescription = "Extra";
                }

                self.userChecking = userChecking;
              })
              .catch((error) => {
                console.log(error);
                self.$message("Erro", error.response.data, "error");
              });
          }
          self.loading = false;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.loading = false;
        });
    },
    getUser: function (id) {
      console.log("getting user " + id);
      let self = this;
      let api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data.data[0];
          console.log(self.user);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  watch: {
    loading: function (newVal, oldVal) {
      console.log(newVal);
      if (newVal) {
        $("#page_loader").show();
      } else {
        $("#page_loader").hide();
      }
    },
  },
  mounted: function () {
    $("#headerNavBar").hide();
    $("#sidebar").hide();
    $("#breadCrumb").hide();

    let self = this;
    let id = self.$route.params.id;

    if (id) {
      self.getUser(id);
    }

    if (document.documentElement.requestFullscreen)
      document.documentElement.requestFullscreen();
    else if (document.documentElement.mozRequestFullScreen)
      document.documentElement.mozRequestFullScreen();
    else if (document.documentElement.webkitRequestFullscreen)
      document.documentElement.webkitRequestFullscreen();
    else if (document.documentElement.msRequestFullscreen)
      document.documentElement.msRequestFullscreen();
  },
  destroyed() {
    $("#headerNavBar").show();
    $("#sidebar").show();
    $("#breadCrumb").show();
    $("body").removeClass("check");
  },
  beforeCreate: function () {
    $("body").addClass("check");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Check/Check.vue